import { render, staticRenderFns } from "./ButtonIconTextFrameless.vue?vue&type=template&id=4a038806&scoped=true&"
import script from "./ButtonIconTextFrameless.vue?vue&type=script&lang=js&"
export * from "./ButtonIconTextFrameless.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIconTextFrameless.vue?vue&type=style&index=0&id=4a038806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a038806",
  null
  
)

export default component.exports